import React from "react";
import { Container, Button, Dropdown, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faBars,
  faRightToBracket,
  faTag,
  faCircleInfo,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function HeaderLanding({ headerVariant = "secondary", theme = "user" }) {
  const { t, i18n } = useTranslation();

  const isPhotographer = theme === "photographer";
  const accentColor = isPhotographer ? "#0f3460" : "#6a11cb";
  const ctaStyle = isPhotographer
    ? { background: "linear-gradient(135deg, #1a1a2e, #0f3460)", color: "#ffd700", fontWeight: 700 }
    : { background: "linear-gradient(135deg, #6a11cb, #c850c0)", color: "white", fontWeight: 700 };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "he", label: "עברית" },
  ];
  const currentLang = (i18n.language || "en").slice(0, 2).toLowerCase();

  return (
    <header
      className="w-100 py-3 shadow-sm"
      style={{ position: "relative", zIndex: 10 }}
    >
      <Container className="d-flex justify-content-between align-items-center">
        {/* Logo */}
        <div className="">
          {/* redirect to "/" */}
            <a href="/">
            <img src="/logo_txt_only.png" alt="Logo" style={{ height: '30px' }} />
          </a>
        </div>

        {/* Desktop Navigation */}
        <div className="d-flex align-items-center gap-3 ms-auto">
        <Nav className="d-none d-md-flex gap-3">
          <Nav.Link href="/login" className="fw-semibold text-dark">
            {t("landing_header.login")}
          </Nav.Link>
          <Nav.Link href="/plans" className="fw-semibold text-dark">
            {t("landing_header.pricing_plans")}
          </Nav.Link>
          <Nav.Link href="/about" className="fw-semibold text-dark" >
            {t("landing_header.about_us")}
          </Nav.Link>
        </Nav>
        <Button
          href="/login"
          size="sm"
          className="d-none d-md-inline-flex align-items-center gap-2 rounded-pill border-0"
          style={{
            ...ctaStyle,
            padding: "8px 20px",
            fontSize: "0.875rem",
            letterSpacing: "0.02em",
            boxShadow: isPhotographer
              ? "0 4px 14px rgba(15, 52, 96, 0.35)"
              : "0 4px 14px rgba(106, 17, 203, 0.35)",
          }}
        >
          <FontAwesomeIcon icon={faBolt} style={{ width: 12 }} />
          {t("hero.create_event")}
        </Button>
        </div>

        {/* Mobile Nav + Language Selector */}
        <div className="d-flex align-items-center gap-2">
          {/* Language selector */}
          <Dropdown>
            <Dropdown.Toggle
              variant={`outline-${headerVariant}`}
              size="sm"
              id="dropdown-lng"
              className="rounded-pill d-flex align-items-center gap-1 no-caret"
              style={{ height: 36, padding: "0 12px" }}
            >
              <FontAwesomeIcon icon={faGlobe} />
              <span className="small fw-semibold" style={{ textTransform: "uppercase" }}>
                {currentLang}
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu
              align="end"
              style={{
                minWidth: 160,
                borderRadius: 16,
                border: "none",
                boxShadow: "0 8px 32px rgba(0,0,0,0.13)",
                padding: "8px",
                marginTop: 8,
              }}
            >
              {languages.map(({ code, label }) => {
                const isActive = currentLang === code;
                return (
                  <Dropdown.Item
                    key={code}
                    onClick={() => changeLanguage(code)}
                    className="rounded-3 d-flex align-items-center gap-2 py-2 px-3"
                    style={isActive ? { backgroundColor: accentColor, color: "white" } : {}}
                  >
                    <span className="fw-medium">{label}</span>
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/* Mobile menu button */}
          <Dropdown className="d-md-none">
            <Dropdown.Toggle
              variant={`outline-${headerVariant}`}
              size="sm"
              className="rounded-pill no-caret d-flex align-items-center justify-content-center"
              style={{ width: 36, height: 36, padding: 0 }}
            >
              <FontAwesomeIcon icon={faBars} />
            </Dropdown.Toggle>

            <Dropdown.Menu
              align="end"
              style={{
                minWidth: 220,
                borderRadius: 16,
                border: "none",
                boxShadow: "0 8px 32px rgba(0,0,0,0.13)",
                padding: "8px",
                marginTop: 8,
              }}
            >
              <Dropdown.Item
                href="/login"
                className="rounded-3 d-flex align-items-center gap-2 py-2 px-3"
              >
                <FontAwesomeIcon icon={faRightToBracket} style={{ color: accentColor, width: 16 }} />
                <span className="fw-medium">{t("landing_header.login")}</span>
              </Dropdown.Item>
              <Dropdown.Item
                href="/plans"
                className="rounded-3 d-flex align-items-center gap-2 py-2 px-3"
              >
                <FontAwesomeIcon icon={faTag} style={{ color: accentColor, width: 16 }} />
                <span className="fw-medium">{t("landing_header.pricing_plans")}</span>
              </Dropdown.Item>
              <Dropdown.Item
                href="/about"
                className="rounded-3 d-flex align-items-center gap-2 py-2 px-3"
              >
                <FontAwesomeIcon icon={faCircleInfo} style={{ color: accentColor, width: 16 }} />
                <span className="fw-medium">{t("landing_header.about_us")}</span>
              </Dropdown.Item>
              <Dropdown.Divider style={{ margin: "6px 8px" }} />
              <Dropdown.Item
                href="/login"
                className="rounded-3 d-flex align-items-center gap-2 py-2 px-3"
                style={ctaStyle}
              >
                <FontAwesomeIcon icon={faBolt} style={{ width: 16 }} />
                <span>{t("hero.create_event")}</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </header>
  );
}